module.exports = __webpack_public_path__ + "static/reversity_university-81a8297718cfc7363d072d620cac34e7.jpg";